import { useMutation } from "react-query";
import APIContact, { IApi } from "../services/APIContact";
import { getContactApiEndpoint } from "../services/Config";
import { NousContacterInput } from "../services/APIContact/swagger";


export const usePostContact = () => {
  const api: IApi = APIContact.create(getContactApiEndpoint());

  return useMutation<any, any, NousContacterInput>(
    // @ts-ignore
    (params: NousContacterInput) =>
      (api &&
        api.postNousContacter(params)) ||
      undefined,
  );
};